<template>
  <div id="app">
<!--    <keep-alive>-->
<!--    <router-view v-if="$route.meta.keepAlive"></router-view>-->
<!--    </keep-alive>-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #272727;
  background: #e3e4e7;
  width: 100%;
  height: 100%;
}
html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
h1, h5, p {
  margin: 0;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue